import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import { SelectOption } from 'src/components/primitives/Select/hooks/types';
import Select from 'src/components/primitives/Select/Select';
import { PortfolioHistoryExportTypeFilter } from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryExportsTable/types';

interface Props {
	exportTypeFilter: PortfolioHistoryExportTypeFilter;
	setExportTypeFilter: (exportType: PortfolioHistoryExportTypeFilter) => void;
}

export default function PortfolioHistoryExportsTableControls({
	exportTypeFilter,
	setExportTypeFilter,
}: Props) {
	const {
		open,
		onOpenChange,
		value,
		onValueChange,
		selectOptions,
		selectedOption,
	} = useSelect({
		selectedValue: exportTypeFilter,
		onSelectedValueChange: setExportTypeFilter,
		options: EXPORT_TYPE_OPTIONS,
	});

	return (
		<PortfolioHistoryTableControls>
			<Select.Root
				open={open}
				onOpenChange={onOpenChange}
				value={value}
				onValueChange={onValueChange}
			>
				<Select.Trigger className="min-w-40" label="Data">
					{selectedOption?.label}
				</Select.Trigger>
				<Select.Options scrollContainerClassName="max-h-50">
					{selectOptions.map((option) => (
						<Select.Option key={option.value} value={option.value}>
							{option.label}
						</Select.Option>
					))}
				</Select.Options>
			</Select.Root>
		</PortfolioHistoryTableControls>
	);
}

const EXPORT_TYPE_OPTIONS: SelectOption<PortfolioHistoryExportTypeFilter>[] = [
	{
		label: 'All',
		value: 'all',
	},
	{
		label: 'Trades',
		value: 'trades',
	},
	{
		label: 'Market Trades',
		value: 'market-trades',
	},
	{
		label: 'Funding Rates',
		value: 'funding-rates',
	},
	{
		label: 'Funding Payments',
		value: 'funding-payments',
	},
	{
		label: 'Deposits/Withdrawals',
		value: 'deposits',
	},
	{
		label: 'Liquidations',
		value: 'liquidations',
	},
	{
		label: 'BAL Records',
		value: 'lp-records',
	},
	{
		label: 'IF Stake Records',
		value: 'if-stake-records',
	},
	{
		label: 'Swap Records',
		value: 'swap-records',
	},
	{
		label: 'Rewards',
		value: 'rewards',
	},
];
